import { split, get, compose } from 'lodash/fp';

export default compose(get(0), split('-'));
